import React, { useState } from 'react'
import styled from 'styled-components'
import ConfirmPopup from './ConfirmPopup'
import DeleteIcon from '../asset/DeleteIcon'
// import SaveIcon from '../../asset/SaveIcon'

const TitleButtonBox = styled.div`
  /* ... 스타일은 기존 그대로 유지 ... */
  display: flex;
  flex-direction: row;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-color: #373a40;
  color: #ffffff;
  justify-content: space-between;
  align-items: center;
  padding: 1em 1.5em;
  font-family: 'SUIT';

  .title {
    font-weight: 700;
    font-size: 1.37rem;
  }

  .button-box {
    display: flex;
    flex-direction: row;
    font-size: 8.7em;
    color: #333333;

    .button {
      width: 41px;
      height: 29px;
      margin-right: 8px;
      padding: 0;
      border: none;
      border-radius: 6px;
      background-color: #e6e6e6;
      cursor: pointer;
    }

    .cancel {
      background-color: transparent;
      color: #cccccc;
    }

    .save {
      margin: 0;
      background-color: #74e3c2;
    }
  }
`

interface Props {
  title: string
  // [수정] 비동기 함수(Promise)도 받을 수 있도록 타입 확장
  onSaveClick?: () => void | Promise<void>
  onDeleteClick?: () => void | Promise<void>
  onCancleClick?: () => void
  onModify?: () => void
  isModify?: boolean
  isCheck?: boolean
}

export const TitleButton = (props: Props) => {
  const {
    title,
    onSaveClick,
    onDeleteClick,
    onCancleClick,
    onModify,
    isModify,
    isCheck,
  } = props

  const [showDeletePopup, setShowDeletePopup] = useState(false)
  const [showSavePopup, setShowSavePopup] = useState(false)

  const handleClickDeleteBtn = () => {
    setShowDeletePopup(true)
  }

  const handleClickSaveBtn = () => {
    setShowSavePopup(true)
  }

  // [수정] 팝업에게 넘겨줄 비동기 함수
  const handleRealDelete = async () => {
    if (onDeleteClick) {
      await onDeleteClick() // 부모의 삭제 로직이 끝날 때까지 대기
    }
    // [중요] 여기서 setShowDeletePopup(false)를 하지 않습니다!
    // ConfirmPopup이 '성공' 화면을 보여준 뒤 스스로 onClose를 호출할 것입니다.
  }

  // [수정] 팝업에게 넘겨줄 비동기 함수
  const handleRealSave = async () => {
    if (onSaveClick) {
      await onSaveClick() // 부모의 저장 로직이 끝날 때까지 대기 (로딩화면 유지)
    }
    // [중요] 여기서 setShowSavePopup(false)를 하지 않습니다!
  }

  return (
    <>
      <TitleButtonBox>
        <div className="title">{title}</div>
        <div className="button-box">
          {isModify ? (
            <button className="button delete" onClick={handleClickDeleteBtn}>
              삭제
            </button>
          ) : (
            <button className="button cancel" onClick={onCancleClick}>
              취소
            </button>
          )}

          {isCheck ? (
            <button className="button save" onClick={onModify}>
              수정
            </button>
          ) : (
            <button className="button save" onClick={handleClickSaveBtn}>
              저장
            </button>
          )}
        </div>
      </TitleButtonBox>

      {/* --- 팝업 컴포넌트들 --- */}

      {/* 1. 삭제 팝업 */}
      {showDeletePopup && (
        <ConfirmPopup
          type="delete"
          title="삭제하시겠습니까?"
          icon={<DeleteIcon />}
          confirmText="삭제하기"
          cancelText="취소"
          // onClose는 '취소' 버튼을 누르거나, '성공' 후 자동 닫힘일 때 실행됨
          onClose={() => setShowDeletePopup(false)}
          onConfirm={handleRealDelete} // async 함수 전달
        />
      )}

      {/* 2. 저장 팝업 */}
      {showSavePopup && (
        <ConfirmPopup
          type="save"
          title="저장하시겠습니까?"
          confirmText="저장하기"
          cancelText="돌아가기"
          // onClose는 '취소' 버튼을 누르거나, '성공' 후 자동 닫힘일 때 실행됨
          onClose={() => setShowSavePopup(false)}
          onConfirm={handleRealSave} // async 함수 전달
        />
      )}
    </>
  )
}
